// API Endpoints
export const API_ENDPOINTS = {
  EMAIL_SENDER: "https://emailsender.elegho.app/api/subscribe",
  GENERAL_EMAIL: "https://emailsender.elegho.app/api/general",
};
export const companyId = "7Dw6sBMQrHLSiHoirHdN";

export const adminEmailAddress = "admin@elegho.com";
export const adminEmailName = "Elegho Admin";
export const appName = "Elegho";
export const domainName = "elegho.app";
export const appURL = "https://elegho.app";
export const companyName = "Elegho";

export const unitNumberLabel = "Unit Number";
export const unitOwnerLabel = "Unit Owner";
export const residentLabel = "Resident";
export const unitLabel = "Unit";

export const phaseLabel = "Tower";
export const blockLabel = "Floor";
export const lotLabel = "Unit";
export const hoaLabel = "Condo Corp";
export const versionNumber = "1.90";

export const unsplashBackground =
  " https://images.unsplash.com/photo-1688680976459-3722d88ec775?q=80&w=3870&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D";
